/*
 * @Description: 直播课堂
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const liveClassroomRouter: Array<RouteRecordRaw> = [
    {
        path: '/liveClassroom',
        component: Layout,
        redirect: '/liveClassroom/teaching',
        children: [
            {
                path: 'teaching',
                component: () => import(/* webpackChunkName: "LiveTeaching" */ '@/views/liveClassroom/teaching/index.vue'),
                name: 'LiveTeaching',
                meta: { title: '实时课堂教学监控' }
            },
            {
                path: 'classroomStatistics',
                component: () => import(/* webpackChunkName: "ClassroomStatistics" */ '@/views/liveClassroom/classroomStatistics/index.vue'),
                name: 'ClassroomStatistics',
                redirect:'/liveClassroom/classroomStatistics/statisticsCourseList',
                meta: { title: '课表清单' },
                children: [
                    {
                        path: 'statisticsCourseList',
                        component: () => import(/* webpackChunkName: "StatisticsCourseList" */ '@/views/liveClassroom/classroomStatistics/courseList.vue'),
                        name: 'StatisticsCourseList',
                        meta: { title: '清单详情' }   
                    },
                    {
                        path: 'removeCourseList',
                        component: () => import(/* webpackChunkName: "RemoveCourseList" */ '@/views/liveClassroom/classroomStatistics/removeCourseList.vue'),
                        name: 'RemoveCourseList',
                        meta: { title: '移除课表清单' }   
                    }]
            },
            {
                path: 'historyClassroom',
                component: () => import(/* webpackChunkName: "HistoryClassroom" */ '@/views/liveClassroom/historyClassroom/index.vue'),
                name: 'HistoryClassroom',
                redirect:'/liveClassroom/historyClassroom/videoList',
                meta: { title: '历史直录播课堂' },
                children: [
                    {
                        path: 'videoList',
                        component: () => import(/* webpackChunkName: "VideoList" */ '@/views/liveClassroom/historyClassroom/vedeoMain.vue'),
                        name: 'VideoList',
                        meta: { title: '课堂列表' }
                    },
                    {
                        path: 'videoRecycleBin',
                        component: () => import(/* webpackChunkName: "VideoRecycleBin" */ '@/views/liveClassroom/historyClassroom/recycleBin.vue'),
                        name: 'VideoRecycleBin',
                        meta: { title: '回收站' }
                    },
                    {
                        path: 'videoDetails',
                        component: () => import(/* webpackChunkName: "VideoDetails" */ '@/views/liveClassroom/historyClassroom/videoDetails.vue'),
                        name: 'VideoDetails',
                        meta: { title: '录像详情' }
                    },
                ]
            },
            {
                path: 'joinCodeSupervise',
                component: () => import(/* webpackChunkName: "joinCodeSupervise" */ '@/views/liveClassroom/joinCodeSupervise/index.vue'),
                name: 'joinCodeSupervise',
                redirect:'/liveClassroom/joinCodeSupervise/joinCode',
                meta: { title: '督导课堂巡课' },
                children: [
                    {
                        path: 'joinCode',
                        component: () => import(/* webpackChunkName: "joinCodeSuperviseIndex" */ '@/views/liveClassroom/joinCodeSupervise/joinCode.vue'),
                        name: 'joinCode',
                        meta: { title: '加课码巡课' }
                    },
                ]
            }
        ]
    }
]

export default liveClassroomRouter
